export default __webpack_public_path__ + "static/media/article  10.777606d4.png";